import React, { Component, PropTypes } from 'react';
import { Link } from 'react-router';
import  Slider  from 'react-slick';
import DocumentMeta from 'react-document-meta';
import GWESliderCard from './GWESliderCard';

class GWESlider extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    let cityObjs = [
      {
        'img': 'Bryan_TX.jpg',
        'name': 'Bryan, TX',
        'date': 'April 7, 2019',
        'url': 'https://www.girlsworldexpo.com/expos/bryan-college-station/2018/'
      },
      {
        'img': 'Hudson_Valley_NY.jpg',
        'name': 'Hudson Valley, NY',
        'date': 'April 14, 2019',
        'url': 'https://www.girlsworldexpo.com/expos/hudson-valley/'
      },
      {
        'img': 'Harrisburg_PA.jpg',
        'name': 'Harrisburg, PA',
        'date': 'October 20, 2019',
        'url': 'https://www.girlsworldexpo.com/expos/harrisburg/'
      },
      {
        'img': 'Pittsburgh_PA.jpg',
        'name': 'Pittsburgh, PA',
        'date': 'March 24, 2019',
        'url': 'https://www.girlsworldexpo.com/find-expo/'
      },
      {
        'img': 'Midland-Odessa_TX.jpg',
        'name': 'Midland-Odessa, TX',
        'date': 'March 30, 2019',
        'url': 'https://www.girlsworldexpo.com/find-expo/'
      },
      {
        'img': 'Lexington_KY.jpg',
        'name': 'Lexington, KY',
        'date': 'January 12, 2019',
        'url': 'https://www.girlsworldexpo.com/expos/lexington/2019/'
      },
      {
        'img': 'Syracuse_NY.jpg',
        'name': 'Syracuse, NY',
        'date': 'November 3, 2019',
        'url': 'https://www.girlsworldexpo.com/expos/syracuse/2018/'
      },
      {
        'img': 'Detroit_MI.jpg',
        'name': 'Detroit, MI',
        'date': 'March 10, 2019',
        'url': 'https://www.girlsworldexpo.com/expos/detroit/2019/'
      },
      {
        'img': 'Indianapolis_IN.jpg',
        'name': 'Indianapolis, IN',
        'date': 'March 16, 2019',
        'url': 'https://www.girlsworldexpo.com/expos/indianapolis/2019/'
      },
      {
        'img': 'Bloomington_IL.jpg',
        'name': 'Bloomington, IL',
        'date': 'March 3, 2019',
        'url': 'https://www.girlsworldexpo.com/expos/bloomington/2019/'
      },
      {
        'img': 'Las_Vegas_NV.jpg',
        'name': 'Las Vegas, NV',
        'date': 'March 19, 2019',
        'url': 'https://www.girlsworldexpo.com/expos/las-vegas/'
      },
      {
        'img': 'Des_Moines_IA.jpg',
        'name': 'Des Moines, IA',
        'date': 'September 29, 2019',
        'url': 'https://www.girlsworldexpo.com/expos/des-moines/2018/'
      },
      {
        'img': 'Buffalo_NY.jpg',
        'name': 'Buffalo, NY',
        'date': 'March 31, 2019',
        'url': 'https://www.girlsworldexpo.com/find-expo/'
      },
      {
        'img': 'Fayetteville_AR.jpg',
        'name': 'Fayetteville, AR',
        'date': 'September 15, 2019',
        'url': 'https://www.girlsworldexpo.com/expos/fayatteville-ar/'
      },
      {
        'img': 'Raleigh_NC.jpg',
        'name': 'Raleigh, NC',
        'date': 'May 10, 2019',
        'url': 'https://www.girlsworldexpo.com/expos/raleigh/2018/'
      },
      {
        'img': 'Southern_Illinois_IL.jpg',
        'name': 'Southern Illinois, IL',
        'date': 'May 5, 2019',
        'url': 'https://www.girlsworldexpo.com/find-expo/'
      },
      {
        'img': 'Staten_Island_NY.jpg',
        'name': 'Staten Island, NY',
        'date': 'October 20, 2019',
        'url': 'https://www.girlsworldexpo.com/expos/staten-island/'
      },
      {
        'img': 'Ft_Wayne_IN.jpg',
        'name': 'Ft. Wayne, IN',
        'date': 'November 10, 2019',
        'url': 'https://www.girlsworldexpo.com/find-expo/'
      },
      {
        'img': 'Fresno_CA.jpg',
        'name': 'Fresno, CA',
        'date': 'March 3, 2019',
        'url': 'https://www.girlsworldexpo.com/expos/fresno/2019/'
      },
      {
        'img': 'Decatur_IL.jpg',
        'name': 'Decatur, IL',
        'date': 'October 27, 2019',
        'url': 'https://www.girlsworldexpo.com/expos/decatur/'
      },
      {
        'img': 'Albany_NY.jpg',
        'name': 'Albany, NY',
        'date': 'December 8, 2019',
        'url': 'https://www.girlsworldexpo.com/expos/albany/'
      },
      {
        'img': 'Colubus_OH.jpg',
        'name': 'Columbus, OH',
        'date': 'September 22, 2019',
        'url': 'https://www.girlsworldexpo.com/expos/columbus/'
      },

    ];
    let cities;
    let imgUrl;
    let cityKey;
    let path = '/images/festival/home/2019/gwe/cities/';

    cities = cityObjs.map((city, idx) => {
      imgUrl = path + city.img;
      cityKey = city + '_' + idx;

      return <div key={cityKey} className="festival-gweCardWrapperOuter">
        <GWESliderCard
          name = {city.name}
          date = {city.date}
          imgUrl = {imgUrl}
          url = {city.url}
        />

      </div>;
    });

    let settings = {
      autoplay: false,
      infinite: true,
      arrows: true,
      slidesToShow: 2,
      slidesToScroll: 1,
      rtl: false
    };

    let browser = this.props.browser;

    if(browser.greaterThan.phablet) {
      settings.slidesToShow = 3;
      settings.slidesToScroll = 1;
    }

    if(browser.greaterThan.tablet) {
      settings.slidesToShow = 4;
      settings.slidesToScroll = 1;
    }

    if(browser.greaterThan.tabletLandscape) {
      settings.slidesToShow = 7;
      settings.slidesToScroll = 7;
    }

    return(
      <div className="festival-gweSliderWrapper">
        <Slider { ...settings }>{cities}</Slider>
      </div>
    );
  }
}

export default GWESlider;



// WEBPACK FOOTER //
// ./src/components/festival/gwe/GWESlider.jsx